




































































































































































































































































































































import {Vue, Component} from 'vue-property-decorator'
import {$} from '@/facade'
import {InputSelect, InputText} from '@simpli/vue-input'

type OrbitDurationUnitId = 'minutes' | 'hours' | 'days' | 'months'

interface OrbitDurationUnitOption {
  $id: OrbitDurationUnitId
  $tag: string
}

@Component({
  components: {
    InputSelect,
    InputText,
  },
  computed: {
    $() {
      return $
    },
  },
})
export default class OrbitSetupFormStep extends Vue {
  roundUnitOptions: OrbitDurationUnitOption[] = []
  claimUnitOptions: OrbitDurationUnitOption[] = []
  distributionUnitOptions: OrbitDurationUnitOption[] = []
  lockoutUnitOptions: OrbitDurationUnitOption[] = []

  roundValue = '14'
  claimValue = '7'
  distributionValue = '7'
  lockoutValue = '30'

  roundUnit: OrbitDurationUnitOption | null = null
  claimUnit: OrbitDurationUnitOption | null = null
  distributionUnit: OrbitDurationUnitOption | null = null
  lockoutUnit: OrbitDurationUnitOption | null = null

  created() {
    const buildOptions = (): OrbitDurationUnitOption[] => [
      {
        $id: 'minutes',
        $tag: this.$translate('components.OrbitSetupFormStep.unitMinutes'),
      },
      {
        $id: 'hours',
        $tag: this.$translate('components.OrbitSetupFormStep.unitHours'),
      },
      {
        $id: 'days',
        $tag: this.$translate('components.OrbitSetupFormStep.unitDays'),
      },
      {
        $id: 'months',
        $tag: this.$translate('components.OrbitSetupFormStep.unitMonths'),
      },
    ]
    // Each multiselect gets its own option instances so shared state / mutations
    // in vue-multiselect cannot bleed across fields.
    this.roundUnitOptions = buildOptions()
    this.claimUnitOptions = buildOptions()
    this.distributionUnitOptions = buildOptions()
    this.lockoutUnitOptions = buildOptions()

    const defaultFrom = (list: OrbitDurationUnitOption[]) =>
      list.find(u => u.$id === 'days') ?? list[0]

    this.roundUnit = defaultFrom(this.roundUnitOptions)
    this.claimUnit = defaultFrom(this.claimUnitOptions)
    this.distributionUnit = defaultFrom(this.distributionUnitOptions)
    this.lockoutUnit = defaultFrom(this.lockoutUnitOptions)
  }

  private valueToMs(amount: string, unitId: OrbitDurationUnitId): number {
    const n = Number(amount)
    if (!Number.isFinite(n) || n <= 0) return 0
    const minuteMs = 60 * 1000
    const hourMs = 60 * minuteMs
    const dayMs = 24 * hourMs
    const monthMs = 30 * dayMs
    switch (unitId) {
      case 'minutes':
        return Math.round(n * minuteMs)
      case 'hours':
        return Math.round(n * hourMs)
      case 'days':
        return Math.round(n * dayMs)
      case 'months':
        return Math.round(n * monthMs)
      default:
        return 0
    }
  }

  get isProceedAllowed() {
    const pairs: [string, OrbitDurationUnitOption | null][] = [
      [this.roundValue, this.roundUnit],
      [this.claimValue, this.claimUnit],
      [this.distributionValue, this.distributionUnit],
      [this.lockoutValue, this.lockoutUnit],
    ]
    return pairs.every(([v, u]) => {
      if (u == null) return false
      const n = Number(v)
      if (v === '' || v == null || !Number.isFinite(n) || n <= 0) return false
      return this.valueToMs(v, u.$id) > 0
    })
  }

  confirmSetup() {
    const ru = this.roundUnit
    const cu = this.claimUnit
    const du = this.distributionUnit
    const lu = this.lockoutUnit
    if (!ru || !cu || !du || !lu) return

    this.$emit('confirm-setup', {
      roundDurationMs: String(this.valueToMs(this.roundValue, ru.$id)),
      claimDurationMs: String(this.valueToMs(this.claimValue, cu.$id)),
      distributionDurationMs: String(
        this.valueToMs(this.distributionValue, du.$id)
      ),
      lockoutDurationMs: String(this.valueToMs(this.lockoutValue, lu.$id)),
    })
  }

  copyToClipboard(address: string) {
    this.$utils.copyToClipboard(address)
    this.$toast.info('system.info.copiedToClipboard')
  }

  closeModal() {
    this.$emit('close')
  }
}
